import type { ClearVerifyStaffAccessInput } from 'src/api';

export const InviteFormFields = {
  emails: 'emails',
} as const;

export type InviteFormValues = ClearVerifyStaffAccessInput & {
  [InviteFormFields.emails]: string[];
};
